import React from 'react';
import { GroupedTimesheets } from '../../components/common/GroupedTimesheets';

export function MyProjectTeam() {
  return <GroupedTimesheets scope="team" pageTitle="My Project's Team" />;
}

export default MyProjectTeam;
